<template>
  <div>
    <v-date-picker
      v-model="dates"
      full-width
      color="primary"
      :show-current="showCurrent"
      no-title
      locale="fr"
      range
      :events="showEvents"
      @input="handleFilter"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';

export default {
  name: 'DatePicker',
  props: {
    attribute: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: 'Date'
    },
    show: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    showCurrent: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return { dates: [] }; // [1738454400, 1740268799]
  },
  computed: {
    ...mapGetters(['getActiveFilter']),
    activeFilter () {
      return this.getActiveFilter(this.attribute);
    }
  },
  watch: {
    activeFilter: {
      immediate: true, // This makes the watcher run on component creation
      handler (newValue) {
        if (!newValue) {
          this.dates = [];
        } else {
          // Convert unix timestamps to ISO 8601 date strings for v-date-picker
          this.dates = newValue.values.map(timestamp => moment.unix(timestamp).format('YYYY-MM-DD'));
        }
      }
    }
  },
  methods: {
    ...mapActions(['applyFilter']),

    handleFilter () {
      const [firstSelection, secondSelection] = this.dates;

      let startDate;
      let endDate;

      if (!firstSelection) return;

      if (!secondSelection) {
        startDate = moment(firstSelection).startOf('day').unix();
        endDate = moment(firstSelection).endOf('day').unix();
      } else {
        const [startMoment, endMoment] = [moment(firstSelection), moment(secondSelection)].sort((a, b) => a - b);

        startDate = startMoment.startOf('day').unix();
        endDate = endMoment.endOf('day').unix();
      }
      this.applyFilter({ attribute: this.attribute, value: [startDate, endDate] });

      this.$emit('input', [startDate, endDate]);
    },
    showEvents (date) {
      const item = this.items.find(facet => moment(facet.value).format('YYYY-MM-DD') === moment(date).format('YYYY-MM-DD'));
      if (!item) return false;

      const hasDraft = item.values.some(facetValues => facetValues.value === 'draft');
      const hasPublished = item.values.some(facetValues => facetValues.value === 'published');

      return [
        hasPublished ? 'teal accent-3' : '',
        hasDraft ? 'blue-grey lighten-4' : ''
      ];
    }
  }
};
</script>
